// PDF Font Configuration for jsPDF
// This file sets up custom fonts for PDF generation

/**
 * Adds Roboto font to jsPDF document
 * @param {jsPDF} doc - The jsPDF document instance
 */
export const addRobotoFont = async (doc) => {
  try {
    // Load Roboto fonts from Google Fonts CDN
    const robotoRegularUrl = 'https://fonts.gstatic.com/s/roboto/v30/KFOmCnqEu92Fr1Me5Q.ttf';
    const robotoBoldUrl = 'https://fonts.gstatic.com/s/roboto/v30/KFOlCnqEu92Fr1MmWUlvAw.ttf';
    
    // Fetch and convert to base64
    const fetchFontAsBase64 = async (url) => {
      const response = await fetch(url);
      const arrayBuffer = await response.arrayBuffer();
      const uint8Array = new Uint8Array(arrayBuffer);
      let binary = '';
      for (let i = 0; i < uint8Array.length; i++) {
        binary += String.fromCharCode(uint8Array[i]);
      }
      return btoa(binary);
    };
    
    const robotoRegularBase64 = await fetchFontAsBase64(robotoRegularUrl);
    const robotoBoldBase64 = await fetchFontAsBase64(robotoBoldUrl);
    
    // Add fonts to jsPDF
    doc.addFileToVFS('Roboto-Regular.ttf', robotoRegularBase64);
    doc.addFont('Roboto-Regular.ttf', 'Roboto', 'normal');
    
    doc.addFileToVFS('Roboto-Bold.ttf', robotoBoldBase64);
    doc.addFont('Roboto-Bold.ttf', 'Roboto', 'bold');
    
    return true;
  } catch (error) {
    console.warn('Failed to load Roboto font, falling back to helvetica:', error);
    return false;
  }
};

/**
 * Adds Lato font to jsPDF document
 * @param {jsPDF} doc - The jsPDF document instance
 */
export const addLatoFont = async (doc) => {
  try {
    const latoRegularUrl = 'https://fonts.gstatic.com/s/lato/v24/S6uyw4BMUTPHvxk.ttf';
    const latoBoldUrl = 'https://fonts.gstatic.com/s/lato/v24/S6u9w4BMUTPHh6UVSwiPHA.ttf';
    
    const fetchFontAsBase64 = async (url) => {
      const response = await fetch(url);
      const arrayBuffer = await response.arrayBuffer();
      const uint8Array = new Uint8Array(arrayBuffer);
      let binary = '';
      for (let i = 0; i < uint8Array.length; i++) {
        binary += String.fromCharCode(uint8Array[i]);
      }
      return btoa(binary);
    };
    
    const latoRegularBase64 = await fetchFontAsBase64(latoRegularUrl);
    const latoBoldBase64 = await fetchFontAsBase64(latoBoldUrl);
    
    doc.addFileToVFS('Lato-Regular.ttf', latoRegularBase64);
    doc.addFont('Lato-Regular.ttf', 'Lato', 'normal');
    
    doc.addFileToVFS('Lato-Bold.ttf', latoBoldBase64);
    doc.addFont('Lato-Bold.ttf', 'Lato', 'bold');
    
    return true;
  } catch (error) {
    console.warn('Failed to load Lato font, falling back to helvetica:', error);
    return false;
  }
};

